import { createOutlineIcon } from "../createIcon";

export const ClockOutlineIcon = createOutlineIcon(
  <>
    <path d="M16.059 15.199a1 1 0 0 0 .632-1.898L16.06 15.2ZM13 13.125h-1a1 1 0 0 0 .684.949l.316-.949Zm1-4.704a1 1 0 1 0-2 0h2Zm2.691 4.88-3.375-1.125-.632 1.898 3.375 1.125.632-1.898ZM14 13.125V8.421h-2v4.704h2ZM21 12a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10h-2Zm-8 8a8 8 0 0 1-8-8H3c0 5.523 4.477 10 10 10v-2Zm-8-8a8 8 0 0 1 8-8V2C7.477 2 3 6.477 3 12h2Zm8-8a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10v2Z" />
  </>,
  "ClockOutlineIcon"
);
